<!-- Not authorized-->
<div class="misc-wrapper">
  <!-- <a class="brand-logo" href="javascript:void(0);">
    <img src="{{ coreConfig.app.appLogoImage }}" alt="brand-logo" height="28" />
    <h2 class="brand-text text-primary ml-1">CMS</h2></a
  > -->
  <div class="misc-inner p-2 p-sm-3">
    <div class="w-100 text-center">
      <div>
        <img
        class="mb-2"
        src="{{ coreConfig.app.appLogoImage }}"
        alt="Not authorized page"
        height="150"
      />
      </div>
      <h2 class="mb-1 text-danger">Not authorized! 🔐</h2>
      <p class="mb-2">
        You are not authorized to access this page.
      </p>
      <a class="btn btn-primary mb-1 btn-sm-block" routerLink="/auth/login" rippleEffect
        >Back to home</a
      >
      
    </div>
  </div>
</div>
<!-- / Not authorized-->
